import React, { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { connect } from 'react-redux';

import UnitsSearchTable from './components/UnitsSearchTable';
import Alert from '../../shared/components/Alert';
import { Link } from 'react-router-dom';
import TrialAlert from '../../shared/components/payment/TrialAlert';
import AlertIcon from 'mdi-react/InformationOutlineIcon';
import EnterpriseGate from '../../shared/components/payment/EnterpriseGate';
import { _hasPermission	} from "../../shared/helpers/access";
import QuickStartGuide from '../../shared/components/QuickStartGuide';
import CalloutBanner from '../../shared/components/CalloutBanner';

import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
  isTablet
} from "react-device-detect";

class Units extends React.Component{
	constructor(props) {
	    super(props);
	    this.state = {
	     
	    };
	}
	componentDidMount() {
	  console.log('componentDidMount Inventory');
	}
	
	render(){
		const { user } = this.props;
	    if(!user) return null;

		return(
		  <Container>
		    <Row>
		      <Col md={12}>
		        <h3 className="page-title">Owner Outreach</h3>
		        {!isMobile && <h3 className="page-subhead subhead">Reach property owners who are ready to transact</h3> }
		      </Col>
		    </Row>
		     {_hasPermission(user, 'owner-outreach') ?
			   <Fragment>
			     <Row>
			      <Col md={12} className={'mb-3'}>
			       	<TrialAlert />        
			      </Col>
			    </Row>
								
				<CalloutBanner
				  storageKey="mp_owner_outreach_banner_v1"
				  variant="purple"
				>
				  {function () {
					return (
					  <div className="d-flex justify-content-between align-items-center flex-wrap">
						<div>
						  <p className="callout-banner-title">
							<img
							  src="https://marketproof.com/images/new-red.png"
							  alt=""
							  style={{ marginRight: 6 }}
							/>
							Owner Contact Info and Insights
						  </p>
				
						  <p className="callout-banner-sub-title mb-2">
							Owner Outreach now includes email and phone, along with work history
							and education, to enable more effective outreach.
						  </p>
						</div>
				 
						<div className="align-items-center mt-2 text-right">
						  <a
							href="http://help.marketproof.com/en/articles/13441323-owner-outreach-introduction"
							target="_blank"
							rel="noopener noreferrer"
							className="btn btn-primary mb-2 callout-banner-btn"
						  >
							Learn more
						  </a>
				
						</div>
					  </div>
					);
				  }}
				</CalloutBanner>

			   {/* <Row>
			    	<Col md={12} className={'mb-3'}>
						<Alert color="success" className="alert--bordered"  alertId="aboutData" icon iconItem={<AlertIcon />} minimizeText={`About The Data`}>
				          <p>
				          	<span className="bold-text">{`About The Data`}</span> 
				            <div>{`The information provided herein is provisional and subject to change as more buildings and units are vetted.`}</div>
				          </p>
				        </Alert>
					</Col>
			    </Row> */}
			   {/* <QuickStartGuide link={"https://youtu.be/LCmbAHbN83c"} type={"Owner Outreach"} /> */}
			    <Row>
			      <UnitsSearchTable />
			    </Row>
		    </Fragment>
		    :
			     <Row>
				   <EnterpriseGate 
				   copy={<span>Access to Owner Outreach requires an upgrade to your subscription.</span>}
				   upgrade={true}
				   user={user}
				   nextPlan={"complete"} />
				 </Row>
			}
		  </Container>
		);
	}
};

export default connect(state => ({
  user: state.user,
}))(Units);



